import React from 'react';
import {Link} from 'react-router-dom';

class ButtonsToolbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let related = [];
    if (this.props.related && this.props.related.length) {
      related = this.props.related.map((link) => {
        var linkClass = '';
        var iconClass = '';

        if (link.type) {
          switch (link.type) {
            case 'primary':
            case 'important':
              linkClass = 'btn-primary';
              break;
            case 'success':
              linkClass = 'btn-success';
              iconClass = 'fa fa-check';
              break;
            case 'danger':
            case 'error':
              linkClass = 'btn-danger';
              iconClass = 'fa fa-exclamation-triangle';
              break;
            case 'edit':
            linkClass = 'btn-primary';
            iconClass = 'fa fa-pencil';
            break;
            case 'add':
              linkClass = 'btn-primary';
              iconClass = 'fa fa-plus';
              break;
            case 'delete':
            case 'remove':
            case 'trash':
              linkClass = 'btn-danger';
              iconClass = 'fa fa-trash';
              break;
            case 'default':
            case '':
              linkClass = 'btn-secondary';
          }
        } else {
          linkClass = 'btn-secondary';
        }
        // override icon if provided
        if (link.icon) {
          iconClass = link.icon;
        }

        if (link.href && !link.onClick) {
          return (
            <Link className={'btn ' + linkClass + ' mr-2'} to={link.href}>
              {iconClass ? <i className={iconClass + ' mr-2'} /> : ''}
              {link.label}
            </Link>
          );
        }
        if (link.onClick) {
          return (
            <a className={'btn ' + linkClass + ' mr-2'} href="javascript:void(0);" onClick={link.onClick}>
              {iconClass ? <i className={iconClass + ' mr-2'} /> : ''}
              {link.label}
            </a>
          );
        }
        if (!link.href && !link.onClick) {
          return (
            <span className={'mr-2'} style={{cursor: 'default'}}>
              {iconClass ? <i className={iconClass + ' mr-2'} /> : ''}
              {link.label}
            </span>
          );
        }
      });
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-8">
            {this.props.back ? <p><Link to={this.props.back.href}><i className="fa fa-arrow-left mr-2" />{this.props.back.label}</Link></p> : ''}
          </div>
          <div className="col-4">
            <p className="text-right">
              {related}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default ButtonsToolbar;


// WEBPACK FOOTER //
// ./src/components/shared/ButtonsToolbar.js